import React, { useState, useEffect } from 'react'
import axios from '../../api/api';
import { toast } from 'sonner';

const Profile = () => {

  // user details
  const currentUser = window.localStorage.getItem('token');
  const user = JSON.parse(currentUser).data.user_data;


  const [first_name, setFirst_name] = useState('');
  const [last_name, setLast_name] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [user_name, setUser_name] = useState('');
  

  // getting user profile
  useEffect(() => {
    const getUser = async () => {
      try {
        const response = await axios.get(`/users/${user.id}`)
        setFirst_name(response.data.first_name)
        setLast_name(response.data.last_name)
        setEmail(response.data.email)
        setPhone(response.data.phone)
      } catch (error) {
        console.log(error)
      }
    }
    getUser()
  },[user.id])

  // update user profile
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      toast.error('Password must have a minimum of 8 characters')
      return
    }
    if (password !== confirmPassword) {
      toast.error('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await axios.put(`/users/profile/${user.id}`,
        { first_name, last_name, password }
      );
      toast.success('Profile updated successfully!');
      setTimeout(() => {
        window.location.reload()
      }, 1000);
    } catch (error) {
      if (!error?.response) {
        toast.error('Network error! Check your connection.');
      } else {
        toast.error('Error updating profile.');
      }
      console.log(error);
    } finally{
      setLoading(false)
    }
  };

  const handleCreate = async (e) => {
    try {
      e.preventDefault();
      const response = await axios.post("/users/api-users/", { user_name }, { responseType: 'blob' });
      const blob = new Blob([response.data], { type: "text/plain" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'api-key.txt');
      document.body.appendChild(link);
      link.click();
      link.remove();
      setUser_name("")
    } catch (error) {
      if (!error?.response) {
        toast.error("Network error! Check your connection.");
      } else if (error.response.status) {
        const responseData = error.response.data;

        // Check if it's a Blob (e.g. from responseType: 'blob')
        if (responseData instanceof Blob) {
          // Try to parse it as JSON and show the detail
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errorJson = JSON.parse(reader.result);
              toast.error(errorJson.detail || "Unknown error occurred.");
            } catch (e) {
              toast.error("Failed to parse server error.");
            }
          };
          reader.readAsText(responseData);
        } else {
          // Normal JSON response
          toast.error(responseData.detail || "Error occurred.");
        }
      } else {
        toast.error("Error creating api user.");
      }
      console.log(error);
    }
  };

  return (
    <div className='mx-auto p-4'>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <div className='p-4 bg-white rounded-lg'>
          <h3 className='text-xl text-center font-bold text-[#134463]'>My Profile.</h3>
          <form onSubmit={handleSubmit}>
            <div className='mt-2'>
              <label htmlFor='fname'>First Name
                <input
                  type='text'
                  required
                  placeholder='First Names'
                  className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] w-full rounded-md focus:ring-1'
                  value={first_name}
                  onChange={(e) => setFirst_name(e.target.value)}
                />
              </label>
            </div>
            <div className='mt-2'>
              <label htmlFor='lname'>Last Name
                <input
                  type='text'
                  required
                  placeholder='Last Names'
                  className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] w-full rounded-md focus:ring-1'
                  value={last_name}
                  onChange={(e) => setLast_name(e.target.value)}
                />
              </label>
            </div>
            <div className='mt-2'>
              <label htmlFor='fullname'>Email
                <input
                  type='text'
                  required
                  disabled
                  placeholder='Email Address'
                  className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] w-full rounded-md focus:ring-1'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </label>
            </div>
            <div className='mt-2'>
              <label htmlFor='phone'>Phone Number
                <input
                  type='number'
                  required
                  disabled
                  placeholder='07000000'
                  className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] w-full rounded-md focus:ring-1'
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </label>
            </div>
            <div className='mt-2'>
              <label htmlFor='Password'>Password <i className='text-red-500'>(Min 8 characters)</i>
                <input
                  type='password'
                  placeholder='Password'
                  className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] w-full rounded-md focus:ring-1'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </label>
            </div>
            <div className='mt-2'>
              <label htmlFor='confirm Password'>Confirm Password
                <input
                  type='password'
                  placeholder='Confirm Password'
                  className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] w-full rounded-md focus:ring-1'
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </label>
            </div>
            <div className='py-3'>
              <button type='submit' disabled={loading} className='bg-[#165277] text-white px-5 py-1 w-full rounded-md hover:bg-[#134463]'>{loading ? 'Please wait...' : 'Update Profile'}</button>
            </div>
          </form>
        </div>

        {user.role === 'CLIENT' && (
          <div className='p-4 bg-white rounded-lg'>
            <h4 className='text-xl text-center font-bold text-[#134463]'>Create Api credentials</h4>
            <form >
              <div className='mt-2'>
                <label htmlFor='name'>Username
                  <input
                    type='text'
                    required
                    placeholder='Name'
                    className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] w-full rounded-md focus:ring-1'
                    value={user_name}
                    onChange={(e) => setUser_name(e.target.value)}
                  />
                </label>
              </div>
              <div className='py-3'>
                <button onClick={handleCreate} type='submit' className='bg-[#165277] text-white px-5 py-1 w-full rounded-md hover:bg-[#134463]'>Create Api user</button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  )
}

export default Profile
